import { css } from "@emotion/react";
// Constants
import { Color } from "../../constants/Colors";
import { FONT_FAMILY } from "../../constants";

export const useStyles = (props) => ({
    bannerContainer: css({
        display: "flex",
        alignItems: "flex-start",
        boxSizing: "border-box",
        padding: 16,
        "& svg": {
            width: 24,
            height: 24,
        },
    }),
    bannerText: css({
        marginLeft: 15,
        fontFamily: FONT_FAMILY.ROBOTO_MEDIUM,
    }),
    alert: css({
        backgroundColor: Color.alert[500],
        color: Color.neutral[900],
        "& svg": {
            color: Color.alert[800],
        },
    }),
    danger: css({
        backgroundColor: Color.danger[800],
        color: Color.neutral[0],
        "& svg": {
            color: Color.alert[0],
        },
    }),
    bannerTypography: css({
        marginLeft: 15,
    }),
});
